export default function radios(local, attrs) {
  local.radios = attrs.type === 'string' ? local : local.string;
}
